import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'

import ContentFrame from 'components/Frame/ContentFrame'
import AssessmentListItem from 'components/Assessment/AssessmentListItem'

export default function AssessmentsTab() {

    const email = useSelector(state => state.athleteProfile.email)

    const [assessments, setAssessments] = useState(null)

    const FetchAssessmentsFromBackend = async () => {

        if (typeof email !== 'string') {
            setAssessments([])
            return
        }

        if (email.length === 0) {
            setAssessments([])
            return
        }

        const jsonBody = {
            email: email
        }

        // console.log(jsonBody);

        const result = await WhichWeightAPI('CORE', 'GET', '/assessment_list', jsonBody)

        // console.log(result.data.data);

        if (result.data.status === 'failure') {
            console.error(result.data)
            setAssessments([])
            return
        }

        setAssessments(result.data.data)
    }

    useEffect(() => { FetchAssessmentsFromBackend() }, [])

    if (assessments === null) {
        return (
            <div className='space-y-4'>
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
            </div>
        )
    }

    return (
        <>
            <ContentFrame className='divide-y divide-gray-200'>
                {assessments.length === 0 &&
                    <div className="text-center text-gray-500 py-4">No assessments found</div>
                }

                {assessments.length > 0 && assessments.map((assessment, index) => (
                    <AssessmentListItem key={index} assessment={assessment} />
                ))}
            </ContentFrame>
        </>
    )
}
